<template>
  <div class="page">
    <div v-show="selectPosition" class="map">
      <iframe id="mapPage" width="100%" height="100%" frameborder=0
              :src="poiSelectURL">
      </iframe>
    </div>
    <div v-show="!selectPosition">
      <h3 class="page__title">网点管理</h3>
      <hr/>
      <a v-show="!addForm" @click="preAdd" style="width:100%;text-align:right;text-underline-offset: 1px;"><i
        class="bi bi-file-earmark-plus"></i> 增加网点 </a>
      <span v-show="!addForm">|</span>
      <a v-show="!addForm" @click="refresh" style="width:100%;text-align:right;text-underline-offset: 1px;"><i
        class="bi bi-arrow-clockwise"></i> 刷新 </a>
    </div>
    <div v-if="addForm == true" v-show="!selectPosition">
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">网点ID</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="请输入ID" maxlength="64"
                 v-model="posInfo.posId"/>
        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">网点名称</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="请输入名称" maxlength="64"
                 v-model="posInfo.name"/>

        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">所属商家</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="请输入商家ID" maxlength="64"
                 v-model="posInfo.partnerId"/>

        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">网点照片</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="点击+号新增，点击图片撤销" maxlength="64"
                 disabled/>

        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__bd weui-flex">
          <div class="uploadFile">
            <!-- ul、li标签用于展示从本地添加的预览图片 -->
            <ul v-show="uploadImg.length!=0">
              <li v-for="(item,index) in uploadImg"
                  :key="index"
                  class="addPic">
                <img :src="item" @click="delPicture(index)">
              </li>
            </ul>
            <input type="file"
                   id="file"
                   accept="image/*"
                   @change="getPicture($event)">
            <button @click="callFile"
                    v-show="showInputImg">+
            </button>
          </div>
        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">省市区</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="选择省" maxlength="2"
                 v-model="posInfo.province" @click="pickProvince()"/> -
          <input class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="选择市" maxlength="2"
                 v-model="posInfo.city" @click="pickCity()"/> -
          <input class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="选择区" maxlength="2"
                 v-model="posInfo.district" @click="pickDistrict()"/>
        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">地址</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="请输入地址" maxlength="64"
                 v-model="posInfo.address"/>
          <button id="js_input_clear" class="weui-btn_reset weui-btn_icon weui-btn_input-clear">
            <i class="weui-icon-clear"></i>
          </button>
        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">经纬度</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="请输入经度" maxlength="64"
                 v-model="posInfo.longitude"/>,
          <input class="weui-input" autofocus type="text" placeholder="请输入纬度" maxlength="64"
                 v-model="posInfo.latitude"/>
          <i class="bi bi-geo-fill" @click="fillPosition"></i>
        </div>
      </div>

      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" placeholder="请输入姓名" maxlength="64"
                 v-model="posInfo.contact"/>

        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">联系电话</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" pattern="[0-9]*" placeholder="请输入电话号码" maxlength="16"
                 v-model="posInfo.phone"/>
          <button id="js_input_clear" class="weui-btn_reset weui-btn_icon weui-btn_input-clear">
            <i class="weui-icon-clear"></i>
          </button>
        </div>
      </div>
      <div class="weui-cell weui-cell_active">
        <div class="weui-cell__hd"><label class="weui-label">营业时间</label></div>
        <div class="weui-cell__bd weui-flex">
          <input class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="开始时间" maxlength="2"
                 v-model="beginHour" @click="pickHour(true)"/> ~
          <input class="weui-input center" autofocus type="text" pattern="[0-9]*" placeholder="结束时间" maxlength="2"
                 v-model="endHour" @click="pickHour(false)"/>
        </div>
      </div>
      <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
          <a @click="addCancel" style="width:40vw" class="weui-btn weui-btn_default">取消</a>
        </div>
        <div class="weui-cell__bd">
          <a @click="addConfirm" style="width:40vw" class="weui-btn weui-btn_primary">确认</a>
        </div>
      </div>

    </div>
    <div v-else>
      <table class="table table-striped " style="font-size: small;" v-if="posList.length >= 1">
        <thead>
        <tr>
          <th>网点ID</th>
          <th>名称</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="itm in posList" :key="itm.posId">
          <td>{{ itm.posId }}</td>
          <td>{{ itm.name }}</td>
          <td><span @click="deletePre">删除</span> | <span @click="editPre(itm)">修改</span></td>
        </tr>
        </tbody>
        <tfoot></tfoot>
      </table>
      <span v-else>您没有任何网点</span>
    </div>
  </div>
</template>

<script>
import JQ from 'jquery'
import Axios from 'axios'
import 'bootstrap/dist/css/bootstrap.css'
import {province} from '../position/china'
import {uploadImage, cosf} from '../cos/image'

import {addPos} from '../graphql/api'

export default {

  data() {
    return {
      // poiSelectURL:"https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK",
      selectPosition: false,
      province: [],
      cityarr: [],
      regionarr: [],
      uploadImg: [],
      posList: [],
      posInfo: {
        posId: "",
        partnerId: "",
        name: "",
        picture: "",
        contact: "",
        phone: "",
        accessType: "",
        openHours: "",
        address: "",
        province: "",
        city: "",
        district: "",
        longitude: sessionStorage.getItem("mylng"),
        latitude: sessionStorage.getItem("mylat"),
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
        modifyTime: "",
        state: 1,
        ywbTag: 1,
        workState: 100
      },
      newFlag: false,
      addForm: false,
      partnerid: "",
      beginHour: 0,
      endHour: 24,
    }
  },
  created() {
    this.provincearr = province
    this.provinceList = [];

    for (let item of this.provincearr) {
      let objTmp = {};

      objTmp.label = item.name;
      objTmp.value = item.id;

      this.provinceList.push(objTmp);
    }

  },
  mounted() {
    this.initPosList()
  },
  computed: {
    showInputImg() {
      return this.uploadImg.length < 3;
    },
    poiSelectURL() {
      if ((this.posInfo.latitude != null) && (this.posInfo.latitude != 0) && (this.posInfo.longitude != null) && (this.posInfo.longitude != 0))
        return "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK&coordtype=5" + "&coord=" + this.posInfo.latitude + "," + this.posInfo.longitude;
      else
        return "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK";
    }
  },
  methods: {
    // 初始化城市
    initCity(pid) {
      for (let item of this.provincearr) {
        if (pid === item.id) {
          console.log(item)
          this.cityarr = item.children
        }
      }

      this.cityList = [];

      for (let item of this.cityarr) {
        let objTmp = {};

        objTmp.label = item.name;
        objTmp.value = item.id;

        this.cityList.push(objTmp);
      }
    },

    // 选择省份
    pickProvince() {
      let that = this;
      this.$weui.picker(this.provinceList, {
        onChange: function (result) {
          console.log(result);
        },
        onConfirm: function (result) {
          console.log(result);
          that.posInfo.province = result[0].label
          that.initCity(result[0].value)
        },
        title: '选择省'
      });
    },

    // 选择城市
    pickCity() {
      if (this.cityList == undefined || this.cityList.length == 0) {

        this.posInfo.city = "";
        this.posInfo.district = "";
        this.pickProvince();
      }
      let that = this;
      this.$weui.picker(this.cityList, {
        onChange: function (result) {
          console.log(result);
        },
        onConfirm: function (result) {
          console.log(result);
          that.posInfo.city = result[0].label
          that.initDistrict(result[0].value)
        },
        title: '选择市'
      });
    },

    // 初始化区
    initDistrict(cid) {
      for (let item of this.cityarr) {
        if (cid == item.id) {
          this.regionarr = item.children
        }
      }

      this.districtList = [];

      for (let item of this.regionarr) {
        let objTmp = {};

        objTmp.label = item.name;
        objTmp.value = item.id;

        this.districtList.push(objTmp);
      }

    },

    // 选择区
    pickDistrict() {
      if (this.districtList == undefined || this.districtList.length == 0) {
        this.posInfo.district = "";
        this.pickCity();
      }
      let that = this;
      this.$weui.picker(this.districtList, {
        onChange: function (result) {
          console.log(result);
        },
        onConfirm: function (result) {
          console.log(result);
          that.posInfo.district = result[0].label
        },
        title: '选择区'
      });
    },

    // 删除图片
    delPicture(idx) {
      this.uploadImg.splice(idx, 1)
    },

    setCosUrl(url) {
      console.log(url)
      this.uploadImg.push(url)

      if (this.uploadImg.length == 1) {
        this.posInfo.picture = url;
      }
    },

    // 自定义一个唯一的图片名，partnerId_posId_length.png
    getImageName(e) {
      let postFix = "png";
      let arr = e.name.split(".");
      if (arr.length >= 1) postFix = arr[arr.length - 1];

      return this.posInfo.partnerId + "_" + this.posInfo.posId + "_" + this.uploadImg.length + "." + postFix;
    },

    // 预览图片
    getPicture(e) {
      //预览图片
      // var url = window.URL || window.webkitURL || window.mozURL;
      // let src = url.createObjectURL(e.target.files[0]);
      // this.uploadImg.push(src);

      console.log(e.target.files[0])  //

      uploadImage(e.target.files[0], this.getImageName(e.target.files[0]), this.setCosUrl)
    },


    callFile() {
      //点击添加图片按钮，触发type:"file"的input标签
      let fileDom = document.querySelector("#file")
      fileDom.click()
    },

    // 初始化网点信息
    initPosInfo(itm) {
      if (itm == null) {
        this.newFlag = true;
        this.posInfo.accessType = 6;
        this.posInfo.address = "";
        this.posInfo.city = "";
        this.posInfo.contact = "";
        this.posInfo.createTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
        this.posInfo.district = "";
        this.posInfo.latitude = 0;
        this.posInfo.longitude = 0;
        this.posInfo.modifyTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
        this.posInfo.name = "";
        this.posInfo.openHours = "00-24"
        {
          this.beginHour = "00";
          this.endHour = "24";
        }
        this.posInfo.partnerId = sessionStorage.getItem("partnerid");
        this.posInfo.phone = "";
        this.posInfo.picture = "";
        this.posInfo.posId = "";
        this.posInfo.province = "";
        this.posInfo.state = 1;
        this.posInfo.ywbTag = 0;
        this.posInfo.workState = 100
      } else {
        {
          console.log(itm._links.self.href)
          let arrTmp = itm._links.self.href.split("/");

          if (arrTmp.length > 1) {
            this.posInfo.id = arrTmp[arrTmp.length - 1];
          }
        }
        this.newFlag = false;
        this.posInfo.accessType = itm.accessType;
        this.posInfo.address = itm.address;
        this.posInfo.city = itm.city;
        //this.posInfo.contact=itm.contact;
        this.$set(this.posInfo, 'contact', itm.contact)
        this.posInfo.createTime = itm.createTime;
        this.posInfo.district = itm.district;
        this.posInfo.latitude = itm.latitude;
        this.posInfo.longitude = itm.longitude;
        this.posInfo.modifyTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
        this.posInfo.name = itm.name;
        this.posInfo.openHours = itm.openHours;
        {
          let varTmp = itm.openHours.split("-");
          if (varTmp.length == 2) {
            this.beginHour = varTmp[0];
            this.endHour = varTmp[1];
          } else {
            this.beginHour = "00";
            this.endHour = "24";
          }
        }
        this.posInfo.partnerId = itm.partnerId;
        this.posInfo.phone = itm.phone;
        this.posInfo.picture = itm.picture;
        {
          this.uploadImg = [];
          this.uploadImg.push(this.posInfo.picture)
        }
        this.posInfo.posId = itm.posId;
        this.posInfo.province = itm.province;
        this.posInfo.state = itm.state;
        this.posInfo.ywbTag = itm.ywbTag;
        this.posInfo.workState = itm.workState
      }
    },
    preAdd() {
      console.log("preAdd")
      this.initPosInfo(null)
      this.addForm = true;
    },
    editPre(itm) {
      console.log("editPre")
      this.initPosInfo(itm);
      this.addForm = true;

    },
    deletePre(itm) {
      console.log("editPre")
      alert("暂时不支持删除，可联系管理员处理")
    },

    addCancel() {
      console.log("addCancel")
      this.addForm = false;
    },

    // 新增网点
    addConfirm() {
      let paras = {};
      paras.posJsonStr = JSON.stringify(this.posInfo);

      let that = this;

      if (this.newFlag) {
        this.posInfo.id = null;
        console.log(this.posInfo);//return;
        Axios.post("/pccs-common-query/posEntities", this.posInfo)
          .then((response) => {
            if (response.data.posId == that.posInfo.posId) {
              alert("新增成功")
            }
          })
      } else {
        console.log(this.posInfo);//return;
        Axios.post("/pccs-common-query/posEntities", this.posInfo)
          .then((response) => {
            console.log(response, that.posInfo.posId)
            if (response.data.posId == that.posInfo.posId) {
              alert("修改成功")
            }
          })
      }
    },

    // 通过partnerId查询当前服务商的所有网点列表
    getPosList(partnetid) {
      let that = this;
      Axios.get('/pccs-common-query/posEntities/search/findByPartnerId?partnerId=' + partnetid + "&tm=" + new Date().getTime()).then(res => {
        console.log(res.data)
        if ((res.data == null) || res.data.length == 0) {
          return;
        }
        console.log(res.data._embedded.posEntities)
        sessionStorage.setItem("posListOf_" + partnetid, JSON.stringify(res.data._embedded.posEntities));
        sessionStorage.setItem("partnerid", partnetid);
        that.initPosList()
        that.ing = false;
      })
    },

    // 刷新列表
    refresh() {
      this.posList = []
      this.getPosList(this.partnerid)
    },

    initPosList() {
      // alert(pid);
      //alert(sessionStorage.getItem("posListOf_"+this.partnerid))
      this.partnerid = sessionStorage.getItem("partnerid")
      this.posList = JSON.parse(sessionStorage.getItem("posListOf_" + this.partnerid));

      //alert(this.posList.length)
    },


    fillPosition() {
      this.selectPosition = true;
      this.addMapEventHandler();
    },

    // 获取到当前地理位置信息
    addMapEventHandler() {
      let that = this;
      window.addEventListener('message',
        function (event) {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          let loc = event.data;
          if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            console.log('location', loc);

            that.posInfo.latitude = loc.latlng.lat;
            that.posInfo.longitude = loc.latlng.lng;

            that.selectPosition = false;
          }
        },
        false
      );
    },

    // 选择网点营业时间
    pickHour(flag) {
      let that = this;
      let optionHour = [];
      for (var i = 0; i <= 24; i++) {
        optionHour.push({"label": i, "value": i});
      }
      this.$weui.picker(optionHour, {
        onChange: function (result) {
          console.log(result, result[0]);
          if (flag) that.beginHour = result[0].value;
          else that.endHour = result[0].value;
        },
        onConfirm: function (result) {
          console.log(result, result[0]);
          if (flag) that.beginHour = result[0].value;
          else that.endHour = result[0].value;

          that.posInfo.openHours = that.beginHour + '-' + that.endHour;
        },
        title: flag ? '选择营业开始时间' : '选择营业结束时间'
      });
    }
  }
}
</script>

<style>
input.right {
  align-content: right;
  text-align: right;
  align-self: right;
  width: 3em
}

input.center {
  align-content: center;
  text-align: center;
  align-self: center;
  width: 3em
}

.uploadFile {
  display: flex;
  height: 100px;
  line-height: 100px;
  padding: 0px;
  border: 1px solid gray;
  overflow: hidden;
}

.uploadFile ul {
  display: flex;
  margin-top: auto;
}

.uploadFile input {
  display: none;
}

.uploadFile ul li {
  margin-top: auto;
  margin-right: 10px;
}

.uploadFile .addPic img {
  margin-top: auto;
  height: 100px;
  width: 100px;
}

.uploadFile button {
  height: 100px;
  width: 100px;
  font-size: 50px;
  border: 1px dashed rgb(182, 182, 182);
  color: rgb(182, 182, 182);
  background-color: rgb(243, 243, 243);
}

.map {
  height: 100vh;
  width: 100vw;
}

</style>



// WEBPACK FOOTER //
// src/views/pos_mgr.vue